import React, { useState } from 'react';
import { Tooltip, ClickAwayListener, IconButton } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import TextWithBullets from './Common/TextWithBullets';

export default function InfoTooltip({ label }) {
    const [isOpen, setIsOpen] = useState(false);

    return label ? (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <Tooltip
                PopperProps={{
                    disablePortal: true,
                }}
                onClose={() => setIsOpen(false)}
                open={isOpen}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={<TextWithBullets inputText={label} wrapperClass='tooltip__ul' />}
            >
                <IconButton onClick={() => setIsOpen(!isOpen)} color='secondary' component='span' size='small'>
                    <InfoIcon />
                </IconButton>
            </Tooltip>
        </ClickAwayListener>
    ) : null;
}
